import React from "react";
import {createRoot} from 'react-dom/client';
import {HashRouter} from "react-router-dom";

import "sweetalert2/dist/sweetalert2.min.css";

import App from "./App";
import {MaterialUIControllerProvider} from "@vendor/context";
import {QueryProvider} from "@app/providers/QueryProvider";

// El HTML del build (index.html) siempre trae <div id="root">; si faltara, createRoot
// tiraría igual en runtime antes de la migración, así que el `!` no cambia el comportamiento.
const container = document.getElementById('root')!;
const root = createRoot(container);
root.render(<HashRouter>
    <QueryProvider>
        <MaterialUIControllerProvider>
            <App/>
        </MaterialUIControllerProvider>
    </QueryProvider>
</HashRouter>);
